import {
    alertHTML,
    b64Uri,
    bodyRequest,
    getData,
    getElement,
    getJson,
    requestOptions,
    resetForm,
    setFocus,
    tryAsyncFetch,
} from "../../../../../../helpers";
import Modal from "bootstrap/js/dist/modal";

export class AccountingplanModalName extends HTMLDivElement {
    connectedCallback() {
        // console.log(this);
        const Form = getElement("[data-form=form]", this);

        Form.elements.save.addEventListener("click", async () => {
            if (Form.reportValidity()) {
                if (getData(Form.elements.save, "data-request") == "http") {
                    Form.submit();
                } else {
                    let body = new FormData(Form);
                    requestOptions.body = body;
                    let response = await tryAsyncFetch(
                        Form.action,
                        requestOptions,
                    );
                    requestOptions.body = bodyRequest; // regresar el bodyRequest predeterminado

                    if (response.errors) {
                        alertHTML(response.message);
                    } else {
                        Form.elements.closeModal.click();
                        alertHTML(getData(Form, "data-message"), "success");
                        // El modo pro solo si lo piden, aquí lanzar un custom event para devolver la data y poder setear el target
                    }
                }
            }
        });

        /**
         * Solución modal anidados bootstrap
         */
        this.addEventListener("click", (e) => {
            const CloseModal = e.target.closest("[data-bs-dismiss=modal]");

            if (CloseModal) {
                const BD = document.querySelectorAll(".modal-backdrop");

                BD.forEach((item) => {
                    item.remove();
                });
                const OldModal = getElement(
                    getData(Form.elements.closeModal, "data-modal-target"),
                );

                if (OldModal) {
                    const M = new Modal(OldModal, {});
                    M.show();
                }
            }
        });

        this.addEventListener("keydown", (e) => {
            // Identificar cuando se presione la tecla esc
            if (e.key === "Escape") {
                const Modal = e.target.closest(".modal");

                Modal?.querySelector("[data-bs-dismiss=modal]")?.click();
            }
        });
        /* *
         * Fin solución modal anidados bootstrap
         */

        this.addEventListener("shown.bs.modal", () => {
            setFocus(Form.elements.name);
        });
    }

    static edit(modal, url, title, data) {
        data = getJson(b64Uri(data, "decode"));
        modal = getElement(modal);
        const form = getElement("[data-form=form]", modal);
        resetForm(form, title, url);

        form.elements.name.value = data.name;
    }
}

window.customElements.define(
    "accountingplanname-modal",
    AccountingplanModalName,
    {
        extends: "div",
    },
);
